<template>
    <div>
        <div v-if="states.length === 0">
            <a :href="__('messages.path')">{{ __('messages.all') }}</a>
        </div>
        <div tabindex="0" class="position-relative" @focusout="handleFocusOut" v-if="states.length">
            <div class="btnTertiary" @click="toggle()">
                {{ selected ? selected : (dispatch.path ? label.name : __('messages.all')) }}
                <span v-if="!active" class="font-icons icons-chevron-down icon-small-pdv"></span>
                <span v-if="active" class="font-icons icons-chevron-up icon-small-pdv"></span>
            </div>

            <div class="position-absolute pdv-dropdown-menu border shadow" v-if="active">
                <div class="border bg-light p-3 d-flex d-sm-none">
                    <span class="font-icons icons-arrow-back mr-2 cursor-pointer" @click="handleFocusOut()"></span> <span>
                        {{ __('messages.select_option') }}
                    </span>
                </div>
                <ul>
                    <li class="border-bottom" @click="selectItem(null)">{{ __('messages.all') }}</li>
                    <li v-for="state in states" class="border-bottom" @click="selectItem(state)">{{ state.name }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        states: Array,
        dispatch: Object
    },
    data() {
        return {
            active: false,
            label: {},
            selected: null,
            culture: window.__pt.cultureData,
            uriHistory: window.location.pathname
        };
    },
    methods: {
        toggle() {
            this.active = !this.active;
        },
        handleFocus() {
            this.active = true;
        },
        handleFocusOut() {
            this.active = false;
        },
        selectItem(state) {
            this.active = false;
            
            if(this.dispatch.path != "") {
                if(state) {
                   // window.location.href = "/" + this.culture.cultureCode + window.i18n.messages.path + state.uri;
                } else {
                    window.location.href = "/" + this.culture.cultureCode + window.i18n.messages.path;
                }
            }

            if (state) {
               // window.history.pushState('', '', "/" + this.culture.cultureCode + window.i18n.messages.path + state.uri);
                this.$emit("selectState", state.name);
                this.selected = state.name;
            } else {
                window.history.pushState('', '', this.uriHistory);
                this.selected = null;
                this.$emit("selectState", null);
            }

        }
    },
    mounted() {
        if (this.dispatch.path !== "") {
            this.label = this.states.find(state => state.uri === this.dispatch.path);
        }
    }
};
</script>
    